import Controller from "./polygon.controller";
import template from "./polygon.html";

const polygon = {
  template,
  controller: Controller,
  bindings: {
    boundary: "<",
    polygons: "<",
    points: "<",
  },
};

export default polygon;



// WEBPACK FOOTER //
// ./src/components/polygon/polygon.component.js